import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import useAPI from '../../../../api';
import { FullSizeCenteredColumn } from '../../../../Components/FlexBox';
import PracticePage from './Pages/PracticePage';
import CustomerPage from './Pages/CustomerPage';
import ProductPage from './Pages/ProductPage';
import PracticeDetailsPage from './Pages/PracticeDetailsPage';
import { FieldRequiredOverrideContext } from '../../../../Components/Form/fieldRequiredContext';
import CustomNewPracticeActions from '../CustomNewPracticeActions';
import { useAtomValue } from 'jotai';
import { selectedBranchAtom } from '../../../../Atoms';
import addCustomerKeysMap from '../../Utils/addCustomerKeysMap';

const practicePages = [
  CustomerPage,
  PracticePage,
  ProductPage,
  PracticeDetailsPage,
];

const DialogContent = function DialogContent({
  edit,
  data,
  customerData,
  inEditing,
  setInEditing,
  currentPage,
  setCurrentPage,
  handleSetCustomerData,
  onClose = () => {},
}) {
  const API = useAPI();
  const methods = useFormContext();

  const selectedBranch = useAtomValue(selectedBranchAtom);

  useEffect(() => {
    setInEditing(false);
    if (data !== null && customerData === null)
      setCurrentPage(edit ? practicePages.length - 1 : 0);
  }, [edit, data]);

  useEffect(() => {
    if (data !== null && customerData === null)
      methods.reset({
        ...data,
        eligible:
          data?.company1 || data?.company2 || data?.company3 ? 'Sì' : 'No',
      });
  }, [data]);

  useEffect(() => {
    if (customerData !== null)
      methods.reset({ ...customerData, dialogType: 'NEW' });
  }, [customerData]);

  const Page = practicePages[currentPage];

  const handleChangePage = async (nSteps) => {
    const newStepIndex = currentPage + nSteps;
    let result = true;
    if (newStepIndex > currentPage) result = await methods.trigger();
    if (result) setCurrentPage(currentPage + nSteps);
  };

  useEffect(() => {
    if (currentPage === 1 && !customerData?.entityId && !edit) {
      const values = methods.getValues();
      API.addCustomer(
        {
          ...addCustomerKeysMap(values),
          branchId: selectedBranch?.id,
          contactTypeId: 1,
        },
        (res) => {
          handleSetCustomerData({
            ...values,
            entityId: res,
          });
        },
        () => {}
      );
    }
  }, [currentPage]);

  // Imported practices (isImported === true) may be incomplete, so when editing
  // one we drop the "required" constraint from every field of the form.
  const requiredDisabled = edit && data?.isImported === true;

  return (
    <FullSizeCenteredColumn gap="16px">
      <FieldRequiredOverrideContext.Provider value={requiredDisabled}>
        <Page
          errors={methods.formState?.errors}
          practiceData={data}
          formData={methods?.getValues()}
          customerData={customerData}
          edit={edit}
          formDirty={methods.formState.isDirty}
          handleSetCustomerData={handleSetCustomerData}
        />
      </FieldRequiredOverrideContext.Provider>
      {(!edit || inEditing) && (
        <CustomNewPracticeActions
          currentPage={currentPage}
          handleChangePage={handleChangePage}
          max={practicePages.length}
          edit={edit && inEditing}
          onCancel={(e) => onClose(e, methods.formState.isDirty)}
        />
      )}
    </FullSizeCenteredColumn>
  );
};

export default DialogContent;
